<template>
	<div id="langselect">
		<img id="logo" :src="logo">
		<ul id="langs" v-if="languages.length > 0">
			<li
				v-for="language in languages"
				:key="language.key"
			><img class="langImage" :ref="'langImg'+ language.id" @click="changeLanguage(language.id)" :src="language.flag"></li>
		</ul>
	</div>
</template>

<script>
import BistrobusLogo from '@/assets/images/logo.png'

export default {

  name: 'LanguageSelector',

  data () {
    return {

    	logo: BistrobusLogo,
		languages: [
			{
				key: 0,
				id: 'fr',
				flag: './images/fr.png'
			},
			{
				key: 1,
				id: 'en',
				flag: './images/en.png'
			},
			{
				key: 2,
				id: 'ch',
				flag: './images/ch.png'
			},
			{
				key: 3,
				id: 'pt',
				flag: './images/pt.png'
			},
			{
				key: 4,
				id: 'es',
				flag: './images/es.png'
			},
			{
				key: 5,
				id: 'nl',
				flag: './images/nl.png'
			},
			{
				key: 6,
				id: 'ru',
				flag: './images/ru.png'
			},
			{
				key: 7,
				id: 'jp',
				flag: './images/jp.png'
			},
			{
				key: 8,
				id: 'it',
				flag: './images/it.png'
			},
			{
				key: 9,
				id: 'de',
				flag: './images/de.png'
			}
		]
    }
  },

  methods: {
	changeLanguage(lang) {
		this.$emit('changelang', lang);
		let images = document.getElementsByClassName('langImage');

	  	for (var i = images.length - 1; i >= 0; i--) {
	  		images[i].style.borderColor = 'white';
	  	}

	  	this.$refs['langImg'+ lang][0].style.borderColor = '#9a312b';
	}
  },

  mounted() {
  	console.log(this.$refs);

  	this.$refs.langImgen[0].style.borderColor = '#9a312b';

  }

}
</script>

<style lang="css" scoped>

.langImage
{
	height: 42px;
	width: 42px;
	border-radius: 500px;
	border: 3px solid white;
}

#logo
{
	width: 20%;
	display: inline-block;
}

ul
{
	list-style: none;
	display: inline-block;
}
li
{
	display: inline-block;
	padding-left: 10px;
}

#langselect
{
	grid-row: 2;
	grid-column: 1;
}

#langs
{
}

</style>